'use client';

import {
  HeroSectionRow as KeziosHeroSection,
  Spacing,
} from '@kezios/design-system';
import { useTranslations } from 'next-intl';

import { HeroCta } from './HeroCta/HeroCta';
import { HeroDescription } from './HeroDescription/HeroDescription';
import { HeroRightSection } from './HeroRightSection/HeroRightSection';
import css from './HeroSection.module.css';

export const HeroSection = ({ currentLocale }: { currentLocale: string }) => {
  const t = useTranslations('section.hero');

  return (
    <KeziosHeroSection
      className={css.container}
      title={t('title')}
      description={<HeroDescription />}
      cta={<HeroCta currentLocale={currentLocale} />}
      rightSection={<HeroRightSection />}
      pb={Spacing.s24}
    />
  );
};
